export const websiteClick = (website) => {
  if (website.includes("http://") || website.includes("https://"))
    window.open(website, "_blank");
  else window.open("https://" + website, "_blank");
};
